import React, { useCallback, useContext, useEffect, useRef} from "react";
import styles from './BusinessCardGen.module.css';
import { BrandCountryContext } from "../../providers/BrandCountryProvider";
import { useNavigate } from "react-router-dom";
import TabNavigation from "../../tabNavigation/TabNavigation";
import { LoggedInContext } from "../../providers/LoggedInContext";
import { toPng } from 'html-to-image';

export default function BusinessCardGen(){

    const { linkObject , handleGetLinkObject } = useContext(LoggedInContext);
    const { brand,setBrand,country,setCountry,language,setLanguage,disable,setDisable,handlePageChange } = useContext(BrandCountryContext);

    const imgRef = useRef(null);

    useEffect(() => {
        setDisable(false);
        handlePageChange(window.location.pathname);
        handleGetLinkObject();
    },[]);

    const scale = 4;

    const onButtonClick = useCallback(() => {
        if (imgRef.current === null) {
        return
        }

        toPng(imgRef.current, { cacheBust: true, canvasWidth: (900*scale), canvasHeight: (500*scale)})
        .then((dataUrl) => {
            const link = document.createElement('a')
            link.download = 'my-image-name.png'
            link.href = dataUrl
            link.click()
        })
        .catch((err) => {
            console.log(err)
        })
    }, [imgRef])


    return(
        <div className={styles.container}>
            <h1>Business Card Generator</h1>
            <br/>
            <div ref={imgRef} className={styles.imgGenContainer}>
                <div className={styles.card}>
                    <h1>John Smith</h1>
                    <br/>
                    <h2>Brand Ambassador</h2>
                    <br/>
                    <br/>
                    <h3>Tel: 012345678910</h3>
                    <br/>
                    <h3>Email: pb@hiq.co.uk</h3>
                    <br/>
                    <br/>
                    <h4>Address Line 1</h4>
                    <h4>Address Line 2</h4>
                    <h4>Town</h4>
                    <h4>County</h4>
                    <h4>Postcode</h4>
                </div>
            </div>
            <br/>
            <button onClick={onButtonClick}>Generate</button>      
        </div>
    )
}